<ui-collapse collapseExpandIconPosition="right">
  <ui-collapse-panel
    *ngFor="let currReflection of currCheckInsModified; let i = index; trackBy: trackByMethod"
    [a11yLabel]="buildPanelAriaLabel(currReflection)"
    [id]="'check-in-' + currReflection.assignee.id"
    [uiLabels]="!currReflection.isActive && (currReflection.labels | filterLabels : filter)"
    [uiIcon]="(!currReflection.isActive || !compareMode) && !currReflection.isEditing && currReflection.mood"
    [collapsePanelActive]="currReflection.isActive"
    [uiIsExpandable]="isPanelEnabled({ isCurrReflectionEmpty: currReflection.noReflection, isPrevReflectionEmpty: prevCheckInsModified[i]?.noReflection, isEditable: currReflection.isEditable })"
    [uiIsCustomHeader]="(!currReflection.isActive && compareMode && !isCheckInsUxImprovementsEnabled) || isCheckInsUxImprovementsEnabled"
    [uiHeaderStyle]="collapsePanelHeaderStyles"
    [ngStyle]="{
      'pointer-events': isPanelEnabled({
        isCurrReflectionEmpty: currReflection.noReflection,
        isPrevReflectionEmpty: prevCheckInsModified[i]?.noReflection,
        isEditable: currReflection.isEditable
      })
        ? 'initial'
        : 'none'
    }"
    [attr.data-test-id]="'check-in-collapse-panel-of-user-' + currReflection.assignee.name"
    (nzActiveChange)="activeChanged({ active: $event }, currReflection.assignee.id)"
    collapsePanelExpandedIcon="chevron-right-big">
    <ng-container
      [ngTemplateOutlet]="compareMode ? compareModeTemplate : defaultModeTemplate"
      [ngTemplateOutletContext]="{ currReflection: currReflection, prevReflection: prevCheckInsModified[i], index: i }"></ng-container>

    <ng-container header>
      <ng-container *ngIf="!compareMode">
        <ng-container *ngIf="isCheckInsUxImprovementsEnabled">
          <ui-assignee class="overview-panel-assignee" *ngIf="currReflection.assignee" [uiAssignee]="currReflection.assignee" [uiNameEllipsis]="true" uiSize="md"></ui-assignee>
          &nbsp;
          <span class="assignee-name-suffix" *ngIf="currReflection.isCurrentUser">(me)</span>
          <div class="ui-collapse-panel-header-extras">
            <div class="ui-collapse-panel-header-extras-icon">
              <i *ngIf="!currReflection.isEditing && currReflection.mood" [class]="currReflection.mood" [uiType]="currReflection.mood" ui-icon></i>
            </div>
            <reflection-label-group
              class="sp-mr-16"
              *ngIf="!currReflection.isActive"
              [labels]="currReflection.labels | filterLabels : filter"
              [maxVisible]="maxVisibleLabels"
              [ngStyle]="{ flex: 'none' }"></reflection-label-group>
          </div>
        </ng-container>
        <ng-container *ngIf="!isCheckInsUxImprovementsEnabled">
          <ui-assignee [uiAssignee]="currReflection.assignee" [uiNameEllipsis]="true" uiSize="sm"></ui-assignee>
          <reflection-label-group [labels]="prevCheckInsModified[i]?.labels | filterLabels : filter"></reflection-label-group>
        </ng-container>
      </ng-container>
      <ng-container *ngIf="compareMode">
        <ui-assignee *ngIf="!isCheckInsUxImprovementsEnabled" [uiAssignee]="currReflection.assignee" [uiNameEllipsis]="true" uiSize="sm"></ui-assignee>
        <ui-assignee class="compare-mode-enabled" *ngIf="isCheckInsUxImprovementsEnabled" [uiAssignee]="currReflection.assignee" [uiNameEllipsis]="true" uiSize="md"></ui-assignee>
        <div class="labels" *ngIf="!currReflection.isActive">
          <reflection-label-group *ngIf="!isCheckInsUxImprovementsEnabled" [labels]="prevCheckInsModified[i]?.labels | filterLabels : filter"></reflection-label-group>
          <reflection-label-group *ngIf="isCheckInsUxImprovementsEnabled" [labels]="prevCheckInsModified[i]?.labels | filterLabels : filter" [maxVisible]="maxVisibleLabels"></reflection-label-group>
          <div class="labels-separator"></div>
          <reflection-label-group *ngIf="!isCheckInsUxImprovementsEnabled" [labels]="currReflection.labels | filterLabels : filter"></reflection-label-group>
          <reflection-label-group *ngIf="isCheckInsUxImprovementsEnabled" [labels]="currReflection.labels | filterLabels : filter" [maxVisible]="maxVisibleLabels"></reflection-label-group>
        </div>
      </ng-container>
    </ng-container>
  </ui-collapse-panel>
</ui-collapse>

<ng-template #defaultModeTemplate let-currReflection="currReflection" let-index="index">
  <div class="sp-px-8 default-mode-template" *ngIf="!currReflection.indicators?.loadingIndicator" data-test-id="check-in-item-content">
    <ng-container *ngIf="!filter || filter === 'published'">
      <reflection-mood
        class="reflection-mood-current"
        *ngIf="(currReflection.isEditing && currReflection?.settings?.moodsEnabled) || (currReflection.noReflection && checkInTemplate.moodsEnabled)"
        [isEditModeEnabled]="currReflection.isEditing"
        [reflectionMood]="currReflection.mood"
        (moodChange)="onMoodUpdate({ type: 'current', mood: $event }, index)"></reflection-mood>
      <ng-container *ngFor="let question of currReflection.questions; let i = index">
        <reflection-question
          class="sp-mb-8 sp-mt-6"
          *ngIf="(question?.answer || currReflection.isEditing || question?.gif?.id) && question.isEnabled"
          [question]="question"
          [isEditModeEnabled]="currReflection.isEditing"
          [attr.data-test-id]="'check-in-question-' + question.question"
          (answerUpdate)="onAnswerUpdate({ type: 'current', question: $event }, index)"></reflection-question>
        <ng-container *featureToggleEnabled="'checkins-interactions'">
          <div
            class="reactions-container"
            *ngIf="(question?.answer || question?.gif?.id) && question.isEnabled && !currReflection.isEditing"
            [class.sp-mb-6]="question?.comments?.length"
            [class.sp-mb-32]="!question?.comments?.length && !question.isCommentsEnabled">
            <reactions
              [(reactions)]="question.reactions"
              [attr.data-test-id]="'check-in-reactions-question-' + question.question"
              [target]="generateCommentTemplate(question.answerId, 'check-in-reaction-answer')"
              [targetParentId]="currReflection.id"
              [metadata]="{ checkinId: currReflection.id, targetType: 'checkin_answer' }"
              targetType="check-in-reaction-answer">
              <button
                class="comments-toggle-button"
                [attr.aria-label]="'add_comment' | localize"
                (click)="
                  onToggleComments(
                    { status: true, type: 'current', target: 'questions', commentParentIndex: i, targetId: question.answerId, scrollToEditor: true },
                    currReflections.indexOf(currReflection)
                  )
                "
                ui-button>
                <i class="fs-16px" ui-icon uiType="comment"></i>
              </button>
            </reactions>
          </div>

          <div
            class="comments-overview sp-mb-32"
            *ngIf="question?.comments?.length && (question?.answer || question?.gif?.id) && !currReflection.isEditing && question.isEnabled && !question.isCommentsEnabled">
            <ui-assignee-avatar-group class="sp-mr-8" [uiMax]="4" uiSize="xs">
              <ui-assignee-avatar *ngFor="let assignee of question.commentsAssignees" [uiAssignee]="assignee" />
            </ui-assignee-avatar-group>
            <checkin-comments-counter
              class="sp-mr-4"
              [attr.aria-label]="buildCheckinCommentsCounterAriaLabel(question.comments) + (getLatestDateFromComments(question.comments) | date : 'MMMM dd, yyyy, HH:mm' | timeAgo : 24)"
              [attr.data-test-id]="'checkin-comments-counter-question-' + question.question"
              [count]="question?.comments?.length"
              (click)="
                onToggleComments(
                  { status: true, type: 'current', target: 'questions', commentParentIndex: i, targetId: question.answerId, scrollToEditor: false },
                  currReflections.indexOf(currReflection)
                )
              "
              (keydown.enter)="
                onToggleComments(
                  { status: true, type: 'current', target: 'questions', commentParentIndex: i, targetId: question.answerId, scrollToEditor: false },
                  currReflections.indexOf(currReflection)
                )
              "
              tabindex="0"></checkin-comments-counter>
            <checkin-latest-comment-date *ngIf="question?.comments?.length" [latestDate]="getLatestDateFromComments(question.comments)"></checkin-latest-comment-date>
          </div>
          <div
            class="comments-container sp-mb-32"
            *ngIf="(question?.answer || question?.gif?.id) && !currReflection.isEditing && question.isEnabled && question.isCommentsEnabled"
            [attr.data-test-id]="'check-in-comments-container-question-' + question.question">
            <checkin-hide-comments-button
              *ngIf="question?.comments?.length"
              (hideComments)="
                onToggleComments(
                  { status: false, type: 'current', target: 'questions', commentParentIndex: i, targetId: question.answerId, scrollToEditor: false },
                  currReflections.indexOf(currReflection)
                )
              ">
            </checkin-hide-comments-button>
            <div class="comments">
              <comments
                #comments
                [initialMentions]="[currReflection.assignee.id]"
                [scrollToComment]="scrollToComment"
                [editorInitialText]="question.commentPendingText"
                [focusEditor]="true"
                [externalActionButtons]="comments.comments?.length === 0"
                [scrollToEditorEvent]="scrollToCommentsEditor$.asObservable()"
                [target]="{ id: question.answerId, type: 'check-in-comment-answer', targetParentId: currReflection.id }"
                [metadata]="{ checkinId: currReflection.id, targetType: 'checkin_comment', cadenceStart: calculateCurrCadenceStartDate(), cadenceEnd: calculateCurrCadenceEndDate() }"
                (add)="onAddComment({ comment: $event, type: 'current', target: 'questions', commentParentIndex: i }, currReflections.indexOf(currReflection))"
                (remove)="onRemoveComment({ comment: $event, type: 'current', target: 'questions', commentParentIndex: i }, currReflections.indexOf(currReflection))"
                (cancel)="
                  question?.comments?.length === 0 &&
                    onToggleComments(
                      { status: false, type: 'current', target: 'questions', commentParentIndex: i, targetId: question.answerId, scrollToEditor: false, source: 'cancelButton' },
                      currReflections.indexOf(currReflection)
                    )
                "
                (textChange)="onChangeCommentPendingText({ text: $event, type: 'current', target: 'questions', commentParentIndex: i }, currReflections.indexOf(currReflection))"></comments>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>
    <ng-container *ngIf="currReflection?.settings?.notesEnabled || (currReflection.noReflection && checkInTemplate.notesEnabled)">
      <ng-container *ngFor="let note of currReflection.notes | filterNotes : filter; let i = index">
        <reflection-note
          *ngIf="note.text || currReflection.isEditing || note?.gif?.id"
          [note]="note"
          [isEditModeEnabled]="currReflection.isEditing && !filter"
          [attr.data-test-id]="'check-in-note-' + note.type"
          (noteChange)="onNoteUpdate({ type: 'current', note: $event, noteIndex: i }, index)"></reflection-note>
        <ng-container *featureToggleEnabled="'checkins-interactions'">
          <div
            class="reactions-container"
            *ngIf="(note?.text || note?.gif?.id) && !currReflection.isEditing"
            [class.sp-mb-6]="note?.comments?.length"
            [class.sp-mb-32]="!note?.comments?.length && !note.isCommentsEnabled">
            <reactions
              [(reactions)]="note.reactions"
              [target]="generateCommentTemplate(note.id, 'check-in-reaction-note')"
              [targetParentId]="currReflection.id"
              [metadata]="{ checkinId: currReflection.id, targetType: 'checkin_' + note.type, fromNoteFilter: isNoteFilterEnabled(filter) }"
              [attr.data-test-id]="'check-in-reactions-note-' + note.type"
              targetType="check-in-reaction-note">
              <button
                class="comments-toggle-button"
                [attr.aria-label]="'add_comment' | localize"
                (click)="
                  onToggleComments(
                    { status: true, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note), targetId: note.id, scrollToEditor: true },
                    currReflections.indexOf(currReflection)
                  )
                "
                ui-button>
                <i class="fs-16px" ui-icon uiType="comment"></i>
              </button>
            </reactions>
          </div>
          <div class="comments-overview sp-mb-32" *ngIf="note?.comments?.length && (note?.text || note?.gif?.id) && !currReflection.isEditing && !note.isCommentsEnabled">
            <ui-assignee-avatar-group class="sp-mr-8" [uiMax]="4" uiSize="xs">
              <ui-assignee-avatar *ngFor="let assignee of note.commentsAssignees" [uiAssignee]="assignee" />
            </ui-assignee-avatar-group>
            <checkin-comments-counter
              class="sp-mr-4"
              [attr.aria-label]="buildCheckinCommentsCounterAriaLabel(note.comments) + (getLatestDateFromComments(note.comments) | date : 'MMMM dd, yyyy, HH:mm' | timeAgo : 24)"
              [attr.data-test-id]="'checkin-comments-counter-note-' + note.type"
              [count]="note?.comments?.length"
              (click)="
                onToggleComments(
                  { status: true, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note), targetId: note.id, scrollToEditor: false },
                  currReflections.indexOf(currReflection)
                )
              "
              (keydown.enter)="
                onToggleComments(
                  { status: true, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note), targetId: note.id, scrollToEditor: false },
                  currReflections.indexOf(currReflection)
                )
              "
              tabindex="0"></checkin-comments-counter>
            <checkin-latest-comment-date *ngIf="note?.comments?.length" [latestDate]="getLatestDateFromComments(note.comments)"></checkin-latest-comment-date>
          </div>
          <div
            class="comments-container sp-mb-32"
            *ngIf="(note?.text || note?.gif?.id) && !currReflection.isEditing && note.isCommentsEnabled"
            [attr.data-test-id]="'check-in-comments-container-note-' + note.type">
            <checkin-hide-comments-button
              *ngIf="note?.comments?.length"
              (hideComments)="
                onToggleComments(
                  { status: false, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note), targetId: note.id, scrollToEditor: false },
                  currReflections.indexOf(currReflection)
                )
              ">
            </checkin-hide-comments-button>
            <div class="comments">
              <comments
                #comments
                [initialMentions]="[currReflection.assignee.id]"
                [scrollToComment]="scrollToComment"
                [editorInitialText]="note.commentPendingText"
                [externalActionButtons]="comments.comments?.length === 0"
                [focusEditor]="true"
                [scrollToEditorEvent]="scrollToCommentsEditor$.asObservable()"
                [target]="{ id: note.id, type: 'check-in-comment-note', targetParentId: currReflection.id }"
                [metadata]="{
                  checkinId: currReflection.id,
                  targetType: 'checkin_comment',
                  cadenceStart: calculateCurrCadenceStartDate(),
                  cadenceEnd: calculateCurrCadenceEndDate(),
                  fromNoteFilter: isNoteFilterEnabled(filter)
                }"
                (add)="onAddComment({ comment: $event, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note) }, currReflections.indexOf(currReflection))"
                (remove)="onRemoveComment({ comment: $event, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note) }, currReflections.indexOf(currReflection))"
                (cancel)="
                  note?.comments?.length === 0 &&
                    onToggleComments(
                      { status: false, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note), targetId: note.id, scrollToEditor: false, source: 'cancelButton' },
                      currReflections.indexOf(currReflection)
                    )
                "
                (textChange)="
                  onChangeCommentPendingText({ text: $event, type: 'current', target: 'notes', commentParentIndex: currReflection.notes.indexOf(note) }, currReflections.indexOf(currReflection))
                "></comments>
            </div>
          </div>
        </ng-container>
      </ng-container>
    </ng-container>

    <checkin-action-buttons
      class="sp-mt-8 sp-mb-8"
      *ngIf="!filter && currReflection.isEditable"
      [checkIn]="currReflection"
      [isCheckInEmpty]="isReflectionEmpty(currReflection)"
      (checkInPublish)="onPublishReflection($event, index)"
      (checkInEdit)="onEditReflection($event, index)"
      (checkInCancel)="onCancelReflection($event, index)"
      type="current"></checkin-action-buttons>
  </div>
  <gh-indicator class="sp-mb-32 sp-mt-16" [(ghValue)]="currReflection.indicators.loadingIndicator" [align]="'center'" [ghMessage]="'loading' | localize"></gh-indicator>
</ng-template>

<ng-template #compareModeTemplate let-currReflection="currReflection" let-prevReflection="prevReflection" let-index="index">
  <reflection-compare
    class="sp-px-8"
    *ngIf="!currReflection?.indicators?.loadingIndicator && !prevReflection?.indicators?.loadingIndicator"
    [checkInTemplate]="checkInTemplate"
    [currReflection]="currReflection"
    [prevReflection]="prevReflection"
    [filter]="filter"
    [currCadenceStartDate]="currCadenceStartDate"
    [prevCadenceStartDate]="prevCadenceStartDate"
    [scrollToCommentsEditor$]="scrollToCommentsEditor$"
    (moodUpdate)="onMoodUpdate($event, index)"
    (noteUpdate)="onNoteUpdate($event, index)"
    (answerUpdate)="onAnswerUpdate($event, index)"
    (fillOut)="onFillOut($event, index)"
    (edit)="onEditReflection($event, index)"
    (cancelEdit)="onCancelReflection($event, index)"
    (publish)="onPublishReflection($event, index)"
    (commentsToggle)="onToggleComments($event, currReflections.indexOf(currReflection))"
    (commentAdd)="onAddComment($event, currReflections.indexOf(currReflection))"
    (commentRemove)="onRemoveComment($event, currReflections.indexOf(currReflection))"
    (commentPendingTextChange)="onChangeCommentPendingText($event, currReflections.indexOf(currReflection))">
  </reflection-compare>
  <gh-indicator
    class="sp-mb-32 sp-mt-16"
    *ngIf="currReflection?.indicators?.loadingIndicator"
    [(ghValue)]="currReflection.indicators.loadingIndicator"
    [align]="'center'"
    [ghMessage]="'loading' | localize"></gh-indicator>
  <gh-indicator
    class="sp-mb-32 sp-mt-16"
    *ngIf="prevReflection?.indicators?.loadingIndicator"
    [(ghValue)]="prevReflection.indicators.loadingIndicator"
    [align]="'center'"
    [ghMessage]="'loading' | localize"></gh-indicator>
</ng-template>

<div class="sp-mt-20" *ngIf="maxReflectionsLength > pageSize">
  <nav [uiPageIndex]="currentPage" [uiTotal]="maxReflectionsLength" [uiPageSize]="pageSize" (uiPageIndexChange)="onPageIndexChange($event)" ui-pagination></nav>
</div>
